/**
 * 数値を 3 桁のカンマ区切り、かつ小数点二桁表示に変換。
 * @param n number
 * @returns string
 */
export function getNumberString(n: number): string {
  return n.toLocaleString('ja-JP', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
}
